import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SOILAPTITUDE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilAptitude.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const SOILAPTITUDE_CONFIG = {
  entityName: 'SoilAptitude',
  localizationKey: 'Planning::Entity.SoilAptitude',
  fields: SOILAPTITUDE_FIELDS,
  permission: 'PlanningGeography.SoilAptitudes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
